import React, { useState, useEffect } from 'react';

import Features from './Features';
import Homepost from './Homepost';
import Latest from './Latest';
import MostPopular from './MostPopular';
import Topbar from './Topbar';
import Onee from '../Homesec/Onee'
import Two from '../Homesec/Two';
import Two1 from '../Homesec/Two1';
import Two2 from '../Homesec/Two2';
import Two3 from '../Homesec/Two3';
import Two4 from '../Homesec/Two4';
import Two5 from '../Homesec/Two5';
import Two6 from '../Homesec/Two6';

const Homee = () => {


    return (

        <>
            {/* Add your components here */}
            <Topbar />
            <Two />
            <Onee />
            <Two1 />
            <Two2 />
            <Two3 />
            <Two4 />
            <Two5 />
            <Two6 />
            <Latest />




        </>
    );
}

export default Homee;
